import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'

import { useTranslation } from '../../i18n/TranslationProvider';

const OnboardingProgress = ({ onboardingPercent }) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h5>{t('header.createAccount')}</h5>

      <div style={{ marginLeft: 'auto', marginRight: '10px' }}>
        {t('header.progress')}: {onboardingPercent}%
      </div>
      <ProgressBar
        now={onboardingPercent}
        max={100}
        variant="info"
        srOnly
        label={`Step ${onboardingPercent} / 100`}
      />
    </div>
  )
}

export default OnboardingProgress